import type { ApiClient } from 'clients/yogi-api'
import type {
  BenchmarkingFeedService,
  FetchBenchmarkingInsightsParams,
} from 'features/trend-detection/features/benchmarking-feed/service/types'
import type {
  AgentFeedOption,
  BenchmarkingInsightsPage,
} from 'features/trend-detection/types'

const BENCHMARKING_URL = '/benchmarking'

interface BenchmarkingAgentSummaryWire {
  uuid: string
  name: string
  is_default: boolean
  is_enabled: boolean
}

export class BenchmarkingFeedHttpService implements BenchmarkingFeedService {
  constructor(private readonly client: ApiClient) {}

  async fetchBenchmarkingInsights({
    projectId,
    page,
    limit,
    sort,
    agentUuid,
    direction,
    period,
  }: FetchBenchmarkingInsightsParams): Promise<BenchmarkingInsightsPage> {
    const { data } = await this.client.get<BenchmarkingInsightsPage>(
      `${BENCHMARKING_URL}/insights`,
      {
        params: {
          proj_uuid: projectId,
          page,
          limit,
          sort,
          period,
          ...(agentUuid ? { agent_uuid: agentUuid } : {}),
          ...(direction ? { direction } : {}),
        },
      },
    )
    return data
  }

  async fetchBenchmarkingAgentOptions(
    projectId: string,
  ): Promise<AgentFeedOption[]> {
    const { data } = await this.client.get<BenchmarkingAgentSummaryWire[]>(
      `${BENCHMARKING_URL}/agents`,
      { params: { proj_uuid: projectId } },
    )
    return data
      .filter((a) => a.is_enabled)
      .map((a) => ({
        uuid: a.uuid,
        name: a.name,
        is_default: a.is_default,
      }))
  }
}
